module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/431.b3ed84ed.png";